import React, { useContext, useEffect, useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import SideCard from "./SideCard/SideCard";
import ProductBanner from "./ProductBanner/ProductBanner";
import FundSummery from "./FundSummery/FundSummery";
import ProductPortfolio from "./ProductPortfolio/ProductPortfolio";
import "../Product/Product.css";
import HistoricalReturn from "./HistoricalReturn/HistoricalReturn";
import ProductFaq from "./ProductFaq/ProductFaq";
import FundDetails from "./FundDetails/FundDetails";
import PortfolioDebt from "./PortfolioDebt/PortfolioDebt";
// import NotFound from "../NotFound/NotFound";
import $ from "jquery";
import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scroller,
} from "react-scroll";
import { replace } from "@amcharts/amcharts5/.internal/core/util/Array";
import { DecryptAESdata, GetPostMethodData} from "../../provider/ServiceProvider";
import URLstateContext from "../../provider/CommonContext";
import NotFound from "../NotFound/NotFound";
// import MidcapPopup from "../HomePopup/MidcapPopup";


function Product(props) {


  const [isValidURL, setIsValidURL] = useState(null);

  // const navigate = useNavigate();
  const { SchemeCode, FundCode, schemeType, SchemeDesc, schemeName } =
    useParams();

  // const [loadingShow, setLoadingShow] = useState(false)

  const fundSummary = useRef(null);
  const portfolio = useRef(null);
  const fundDetails = useRef(null);
  const performance = useRef(null);
  const faq = useRef(null);
  const [path, setPathname] = useState("");
  const [loadingshow, setloadingshow] = useState(false);
  const { BaseURL } = useContext(URLstateContext);
  const [dataAll, setDataAll] = useState([]);
   const [isValidPage, setIsValidPage] = useState(true);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const location = useLocation();
  let getSchemeCode = props.SchemeCode;




  useEffect(() => {
   
    if (location.state != null && location.state.plan != "") {
      handleSideChange();
    }
 
    // debugger;
    // const urPathSeg = window.location.pathname.split("/");
    // console.log("urPathSeg", urPathSeg);
  
    // // const formattedSchemeName = schemeName?.replace(/-/g, " ") : "";
    // const formattedSchemeName = schemeName?.replace(/-/g, " ")
    // const formattedSchemeDesc = SchemeDesc?.replace(/-/g, " ")
    // const formattedSchemeType = schemeType?.replace(/-/g, " ")

    // const isValidType = urlSchemeType.includes(formattedSchemeType);
    // const isValidName = urlSchemeName.includes(formattedSchemeName);
    // const isValidDesc = urlSchemeDesc.includes(formattedSchemeDesc);

    // const isValidURL = isValidType && isValidName && isValidDesc

    // if (isValidType && isValidName && isValidDesc) {
    //   navigate("/404", { replace: true })
    // } 

    // if(!(isValidURL)){
    //   navigate("/404", { replace: true });
    // }
  
    // var pathname = window.location.pathname;
    // // console.log("pathname:",pathname)
    // const regEx = new RegExp("-", "g");
    // const resultName = pathname.replace(regEx, " ");
    // // alert("Resultname-",resultName)
    // setPathname(resultName);

    window.addEventListener("scroll", snapshottabscroll);
    return () => {
      window.removeEventListener("scroll", snapshottabscroll);
    };
  });

    
  // useEffect(() => {
  //   if (SchemeCode === "J644") {
  //     // console.log("Midcap Fund Triggered!!!");
  //     setIsPopupOpen(true);     
  //   }
  // }, [SchemeCode]);

  const schemePlan = SchemeDesc === "Direct-Plan-Growth-Option" ? "Direct" : "Regular";

// ============================================================================

//  useEffect(() => {
//     // debugger;
//     const fetchData = async () => {
//       setloadingshow(true); 
//       try {
//         const data = await GetPostMethodData(BaseURL + "GetDynamicUrlData", {
//           urlCategory: SchemeCode   
//         });
//         // alert(SchemeCode)

//         setloadingshow(false);  
//         // debugger
//         if (data.data != null && data.data.length > 0) {
//           const decryptedData = DecryptAESdata(data.data); 
//           setDataAll(decryptedData); 
          
//           const formattedSchemeName = schemeName?.replace(/-/g, " ");
//           const formattedSchemeDesc = SchemeDesc?.replace(/-/g, " ");
//           const formattedSchemeType = schemeType?.replace(/-/g, " ");
         
//           const isValid = decryptedData.some((item) => {

//             console.log("Validating Item:");
//             console.log("Item categoryName:", item.categoryName); 
//             console.log("Item FundName:", item.FundName); 
//             console.log("Item PlanDesc:", item.PlanDesc); 

//             console.log("Comparing with URL parameters:");
//             console.log("Formatted Scheme Type:", formattedSchemeType); 
//             console.log("Formatted Scheme Name:", formattedSchemeName); 
//             console.log("Formatted Scheme Desc:", formattedSchemeDesc);

//             return (
//               item.categoryName === formattedSchemeType &&
//               item.FundName === formattedSchemeName &&
//               item.PlanDesc === formattedSchemeDesc
//             );
//           });
 
//           if (!isValid) {
//             setIsValidPage(false)
//             // navigate("/404", { replace: true });
//           }
//         } else {
//             setIsValidPage(false)
//           // navigate("/404", { replace: true });
//         }
//       } catch (error) {
//         setloadingshow(false);
//         setIsValidPage(false) 
//         // alert("Erorrr aa gaya @!!!")
//         // navigate("/404", { replace: true }); 
//       }
//     };

//     if (schemeName && SchemeDesc && schemeType && SchemeCode) {
//       fetchData(); 
//     }
//   }, [BaseURL, schemeName, SchemeDesc, schemeType, SchemeCode])

// =====================================================================================

 
  const snapshottabscroll = (e) => {
    const fixsc = document.querySelector(".product-container");
    const scrollTop = window.scrollY;
    scrollTop >= 0
      ? fixsc.classList.add("tab-sticky")
      : fixsc.classList.remove("tab-sticky");
  };

  const scrollDown = (ref) => {
    var idSummary = document.getElementById("summary");
    var idPort = document.getElementById("portFund");
    var idDetails = document.getElementById("detailsFund");
    var idPerform = document.getElementById("performFund");
    var idFaq = document.getElementById("faqFund");
    if (ref.current.id === "fund-summary") {
      idSummary.classList.add("active");
      idPort.classList.remove("active");
      idPerform.classList.remove("active");
      idDetails.classList.remove("active");
      if (schemeType != "Fixed-Income") {
        idFaq.classList.remove("active");
      }
    }
    if (ref.current.id === "fund-port") {
      idPort.classList.add("active");
      idSummary.classList.remove("active");
      idPerform.classList.remove("active");
      idDetails.classList.remove("active");
      if (schemeType != "Fixed-Income") {
        idFaq.classList.remove("active");
      }
    }
    if (ref.current.id === "fund-perform") {
      idPerform.classList.add("active");
      idSummary.classList.remove("active");
      idPort.classList.remove("active");
      idDetails.classList.remove("active");
      if (schemeType != "Fixed-Income") {
        idFaq.classList.remove("active");
      }
    }
    if (ref.current.id === "fund-details") {
      idDetails.classList.add("active");
      idSummary.classList.remove("active");
      idPort.classList.remove("active");
      idPerform.classList.remove("active");
      if (schemeType != "Fixed-Income") {
        idFaq.classList.remove("active");
      }
    }
    if (ref.current.id === "fund-faq") {
      idFaq.classList.add("active");
      idSummary.classList.remove("active");
      idPort.classList.remove("active");
      idPerform.classList.remove("active");
      idDetails.classList.remove("active");
    }
    window.scrollTo({
      top: ref.current.offsetTop,
      behavior: "smooth",
    });
  };

  const handleSideChange = () => {
    var idPerformSide = document.getElementById("performFund");
    var idSummarySide = document.getElementById("summary");
    var idPortSide = document.getElementById("portFund");
    var idDetailsSide = document.getElementById("detailsFund");
    var idFaqSide = document.getElementById("faqFund");
    idSummarySide.classList.remove("active");
    idPortSide.classList.remove("active");
    idDetailsSide.classList.remove("active");
    if (schemeType != "Fixed-Income") {
      idFaqSide.classList.remove("active");
    }
    idPerformSide.classList.add("active");
    window.scrollTo({
      top: performance.current.offsetTop,
      behavior: "smooth",
    });
  };
  // const Url = window.location.pathname.split("/");
  // console.log("Url", Url);

  //  if (!isValidPage) {
  //     return <NotFound />;
  //   }
  
  return (
    <>
      <main className="product-main" id="main-content" tabIndex="-1">
         <h1 className="sr-only">
          {schemeName ? schemeName.replace(/-/g, " ").trim() : "Products"}
        </h1>

        <Container>
          <Row>
            <Col>
            <nav className="Breadcrumb">
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right"></i>
                </li>
                <li>
                  <a href="/products">Products</a>{" "}
                  <i class="fa fa-angle-right"></i>
                </li>
                {/* <li>{path.replace("-", " ")}</li> */}
                {/* <li>{schemeName ? schemeName.replace(/-/g, " ") : ""}</li> */}
                
                  {schemeName?.trim() && (
                    <li aria-current="page">
                      {schemeName.replace(/-/g, " ").trim()}
                    </li>
                  )}
              </ul>
            </nav>
            </Col>
          </Row>
        </Container>

        <Container className="container product-container">
          <Row className="flex-lg-row flex-column">
            <Col lg={4} md={12} className="product-left">
              <SideCard SchemeCode={SchemeCode} FundCode={FundCode}/>
            </Col>
            <Col lg={8} md={12} className="product-right">
              <div class="product_section-tab-desktop">
                {/* <ul>
                  <li>
                    <a id="summary" onClick={() => scrollDown(fundSummary)}>
                      Fund Summary
                    </a>
                  </li>
                  <li>
                    <a id="portFund" onClick={() => scrollDown(portfolio)}>
                      Portfolio
                    </a>
                  </li>
                  <li>
                    <a id="detailsFund" onClick={() => scrollDown(fundDetails)}>
                      Fund Details
                    </a>
                  </li>
                  <li>
                    <a id="performFund" onClick={() => scrollDown(performance)}>
                      Performance
                    </a>
                  </li>
                  {schemeType === "Fixed-Income" ? (
                    ""
                  ) : (
                    <li>
                      <a id="faqFund" onClick={() => scrollDown(faq)}>
                        FAQ's
                      </a>
                    </li>
                  )}
                </ul> */}

                <ul>
                    <li>
                      <button
                        type="button"
                        id="summary"
                        onClick={() => scrollDown(fundSummary)}
                      >
                        Fund Summary
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        id="portFund"
                        onClick={() => scrollDown(portfolio)}
                      >
                        Portfolio
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        id="detailsFund"
                        onClick={() => scrollDown(fundDetails)}
                      >
                        Fund Details
                      </button>
                    </li>

                    <li>
                      <button
                        type="button"
                        id="performFund"
                        onClick={() => scrollDown(performance)}
                      >
                        Performance
                      </button>
                    </li>

                    {schemeType !== "Fixed-Income" && (
                      <li>
                        <button
                          type="button"
                          id="faqFund"
                          onClick={() => scrollDown(faq)}
                        >
                          FAQ's
                        </button>
                      </li>
                    )}
                  </ul>

                  {/* <li>
                    <a href="" class="invest-btn">
                      Invest
                    </a>
                  </li> */}
              </div>
              {/* <ProductBanner SchemeCode={SchemeCode} /> */}
              <div className="page-section" id="fund-summary" ref={fundSummary}>
                <FundSummery
                  SchemeCode={SchemeCode}
                  SchemeDesc={SchemeDesc}
                  schemeName={schemeName}
                />
              </div>
              {schemeType != "Fixed-Income" ? (
                <div className="page-section" id="fund-port" ref={portfolio}>
                  <ProductPortfolio SchemeCode={SchemeCode} SchemePlans={schemePlan}/>
                </div>
              ) : (
                <div className="page-section" id="fund-port" ref={portfolio}>
                  <PortfolioDebt SchemeCode={SchemeCode} SchemePlans={schemePlan}/>
                </div>
              )}
              <div className="page-section" id="fund-perform" ref={performance}>
                <HistoricalReturn
                  SchemeCode={SchemeCode}
                  SchemeDesc={SchemeDesc}
                  schemename = {schemeName}
                />
              </div>
              <div className="page-section" id="fund-details" ref={fundDetails}>
                <FundDetails SchemeCode={SchemeCode} SchemeDesc={SchemeDesc} />
              </div>
              {schemeType === "Fixed-Income" ? (
                ""
              ) : (
                <div className="page-section" id="fund-faq" ref={faq}>
                  <ProductFaq SchemeCode={SchemeCode} />
                </div>
              )}
            </Col>
          </Row>
        </Container>

        </main>

            {/* {isPopupOpen && (
              <MidcapPopup show={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
              )} */}
    </>
  );
}

export default Product;

